module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bd2d7b2437946f1add631d2a55997b2f.gif";